import compat from '../common/compat';

import PagePagePC from './components/PagePagePC';
import HomePage from './components/HomePage';
import HeaderSlideShowView from './components/HeaderSlideShowView';
// import DlDiscussionListItem from './components/DlDiscussionListItem';


export default Object.assign(compat, {
  'dlIndex/components/PagePagePC': PagePagePC,
  'dlIndex/components/HomePage': HomePage,
  'dlIndex/components/HeaderSlideShowView': HeaderSlideShowView,
  // 'dlIndex/components/DlDiscussionListItem': DlDiscussionListItem,
});
